import { combineReducers } from "redux";

import { departmentsDetails } from "./reducer.departments"
const departmentReducers = combineReducers({

  departmentsDetails

})
export default departmentReducers;
